// src/components/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { app, db } from "../firebase-config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);
  const firebaseAuth = getAuth(app);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, async (loggedInUser) => {
      if (loggedInUser) {
        try {
          const userDocRef = doc(db, "users", loggedInUser.uid);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            // Merge Firestore document data with the basic auth user data.
            setUser({ ...loggedInUser, ...userDocSnap.data() });
          } else {
            setUser(loggedInUser);
          }
        } catch (error) {
          console.error("Error fetching additional user data:", error);
          setUser(loggedInUser);
        }
      } else {
        setUser(null);
      }
      setInitializing(false);
    });

    return () => unsubscribe();
  }, [firebaseAuth]);

  const logout = () => signOut(firebaseAuth);

  return (
    <AuthContext.Provider value={{ user, logout, initializing }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);